<template>
  <v-card class="pa-4" outlined>
    <!-- Header -->
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12" md="6">
        <v-card-text class="pa-0 ma-0 text-body-1 text-right">
          {{ $t("bIpaybox") }}
        </v-card-text>
      </v-col>
      <v-col cols="12" md="6" class="text-left">
        <v-btn @click="advancedFilterDrawer = true" small outlined>
          {{ $t("advancedFilters") }}
          <v-icon right>mdi-filter</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="pa-0 ma-0 filters-row" no-gutters>
      <v-col
        cols="12"
        md="3"
        class="pa-1 ma-0"
        :class="['pa-0 ma-0', isTablet || isMobile ? 'mt-4' : '']"
      >
        <template>
          <v-text-field
            id="start"
            v-model="filters.fromDate"
            :label="$t('date')"
            clear-icon="flaticon2-close-cross"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-calendar-month"
          />
          <date-picker
            v-model="filters.fromDate"
            element="start"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :min="$store.state.startDate"
            :max="$store.state.endDate"
            :color="
              this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @close="setDate"
          />
        </template>
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="pa-1 ma-0"
        :class="['pa-0 ma-0', isTablet || isMobile ? 'mt-4' : '']"
      >
        <template>
          <v-text-field
            id="end"
            v-model="filters.toDate"
            :label="$t('date')"
            clear-icon="flaticon2-close-cross"
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-calendar-month"
          />
          <date-picker
            v-model="filters.toDate"
            element="end"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :min="$store.state.startDate"
            :max="$store.state.endDate"
            :color="
              this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light']
                .primary
            "
            @close="setDate"
          />
        </template>
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="pa-1 ma-0"
        :class="['pa-0 ma-0', isTablet || isMobile ? 'mt-4' : '']"
      >
        <autocomplete
          v-model="filters.account"
          :title="$t('customer')"
          type="person"
          :filter="true"
          :multiple="true"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
        class="pa-1 ma-0"
        :class="['pa-0 ma-0', isTablet || isMobile ? 'mt-4' : '']"
      >
        <autocomplete
          v-model="filters.branch"
          :title="$t('branch')"
          type="branch"
          :filter="true"
          :multiple="true"
        />
      </v-col>
    </v-row>
    <!-- Active Filters -->
    <v-row class="mt-4">
      <v-col cols="12" class="d-flex align-center flex-wrap">
        <v-card-text class="pa-0 ma-0 text-body-1 grey--text text--darken-1 ml-2">
          {{ $t("activeFilters") }}
        </v-card-text>

        <v-chip
          v-if="filters.sellStatus"
          close
          small
          class="ma-1 pa-4"
          color="#E8F2FF"
          text-color="#2F6DE1"
          @click:close="closeStatus"
        >
          {{ $t("status") }} {{ filters.sellStatus.name }}
        </v-chip>

        <v-chip
          v-if="filters.branch?.length"
          close
          small
          class="ma-1 pa-4"
          color="#E8F2FF"
          text-color="#2F6DE1"
          @click:close="filters.branch = null"
        >
          {{ $t("branch") }} ({{ filters.branch.length }})
        </v-chip>

        <v-chip
          v-if="filters.account?.length"
          close
          small
          class="ma-1 pa-4"
          color="#E8F2FF"
          text-color="#2F6DE1"
          @click:close="filters.account = null"
        >
          {{ $t("customer") }} ({{ filters.account.length }})
        </v-chip>

        <v-chip
          v-if="filters.fromDate"
          close
          small
          class="ma-1 pa-4"
          color="#E8F2FF"
          text-color="#2F6DE1"
          @click:close="filters.fromDate = null"
        >
          {{ $t("fromDate") }} {{ filters.fromDate }}
        </v-chip>

        <v-chip
          v-if="filters.toDate"
          close
          small
          class="ma-1 pa-4"
          color="#E8F2FF"
          text-color="#2F6DE1"
          @click:close="filters.toDate = null"
        >
          {{ $t("toDate") }} {{ filters.toDate }}
        </v-chip>

        <v-spacer />

        <v-btn class="mx-1" text small color="red" @click="resetFilters">
          {{ $t("clearAll") }}
        </v-btn>

        <v-btn small color="blue" @click="applyFilters">
          {{ $t("filter") }}
        </v-btn>
      </v-col>
    </v-row>
    <!-- advance filter -->
    <v-navigation-drawer
      v-model="advancedFilterDrawer"
      fixed
      left
      temporary
      width="360"
      class="pa-0 py-2 ma-0"
    >
      <div class="d-flex justify-space-between flex-column" style="height: 100%">
        <!-- top section -->
        <v-container class="pa-0 ma-0 flex-grow-1" style="height: 100%">
          <!-- Header -->
          <v-container class="pa-0 ma-0">
            <v-container class="pa-0 ma-0 d-flex align-center justify-space-between">
              <v-container class="pa-0 pr-2 py-1 ma-0 d-flex flex-column gap-1">
                <v-card-text class="pa-0 ma-0 text-body-2">
                  {{ $t("advancedFilters") }}
                </v-card-text>
                <v-card-text class="pa-0 ma-0 grey--text text-body-2">
                  {{ $t("selectDesiredFilters") }}
                </v-card-text>
              </v-container>
              <v-btn icon @click="advancedFilterDrawer = false">
                <v-icon color="grey"> mdi-close </v-icon>
              </v-btn>
            </v-container>
          </v-container>
          <v-divider />
          <!-- Filters -->
          <v-container class="pa-0 px-3 py-3 ma-0 d-flex flex-column gap-3">
            <v-container class="pa-0 my-2 mb-5 ma-0 d-flex">
              <template>
                <v-text-field
                  id="adv-start"
                  v-model="advancefilters.fromDate"
                  :label="$t('date')"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-calendar-month"
                  class="pa-0 ml-2"
                />
                <date-picker
                  v-model="advancefilters.fromDate"
                  element="adv-start"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="$store.state.startDate"
                  :max="$store.state.endDate"
                  :color="
                    this.$vuetify.theme.themes[
                      this.$vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </template>
              <template>
                <v-text-field
                  id="adv-end"
                  v-model="advancefilters.toDate"
                  :label="$t('date')"
                  clear-icon="flaticon2-close-cross"
                  outlined
                  dense
                  clearable
                  prepend-inner-icon="mdi-calendar-month"
                />
                <date-picker
                  v-model="advancefilters.toDate"
                  element="adv-end"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :min="$store.state.startDate"
                  :max="$store.state.endDate"
                  :color="
                    this.$vuetify.theme.themes[
                      this.$vuetify.theme.isDark ? 'dark' : 'light'
                    ].primary
                  "
                  @close="setDate"
                />
              </template>
            </v-container>
            <v-container class="pa-0 ma-0 d-flex flex-column gap-7">
              <v-container
                class="pa-0 ma-0 my-4 d-flex justify-space-between align-center gap-2"
              >
                <v-card-text class="pa-0 ma-0 text-body-1 text-right">
                  {{ $t("hasReceipt") }}
                </v-card-text>
                <v-switch v-model="filters.Receipt" inset class="mb-1 ma-0 pa-0" />
              </v-container>

              <!-- <status v-model="advancefilters.sellStatus" :hideconfig="true" />
              <autocomplete
                v-model="advancefilters.account"
                :title="$t('customer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="advancefilters.branch"
                :title="$t('branch')"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <FlexibleAutocomplete
                v-model="advancefilters.UserList"
                title="user"
                :currency="currencyId"
                :fetchData="fetchCustomersApi"
              /> -->
            </v-container>
            <!-- Amount Range -->
            <v-card-text class="pa-0 ma-0 mt-3 text-body-2">{{
              $t("amount_range_million_rials")
            }}</v-card-text>
            <v-container class="pa-0 ma-0 d-flex flex-column">
              <v-range-slider
                v-model="advancefilters.amountRange"
                :min="0"
                :max="maxAmount || 100"
                height="14"
                step="1"
                color="black"
                track-color="grey lighten-2"
                class="ma-0 pa-0"
              />
              <v-container class="d-flex justify-space-between pa-0 ma-0">
                <v-card-text class="pa-0 ma-0 text-body-2"
                  >{{ selectedMinAmount }} {{ $t("million") }}</v-card-text
                >
                <v-card-text class="pa-0 ma-0 text-body-2"
                  >{{ selectedMaxAmount }} {{ $t("million") }}</v-card-text
                >
              </v-container>
            </v-container>

            <v-container class="pa-0 ma-0 d-flex flex-column gap-7">
              <!-- <FlexibleAutocomplete
                v-model="advancefilters.products"
                title="product"
                :currency="currencyId"
                :fetchData="fetchProductsApi"
              /> -->
              <!-- <autocomplete
                v-model="advancefilters.productGroup"
                :title="$t('productGroup')"
                type="productGroup"
                :data="{ parent: null, type: 'group' }"
                :multiple="false"
              /> -->
            </v-container>
          </v-container>
        </v-container>
        <!-- Footer Buttons -->
        <v-container class="pa-0 px-3 ma-0 d-flex gap-1">
          <v-btn
            class="flex-grow-1 ml-1"
            small
            height="44"
            outlined
            color="grey darken-1"
            @click="resetAdvancedFilters"
          >
            {{ $t("clearAll") }}
          </v-btn>
          <v-btn
            class="white--text flex-grow-1 mr-1"
            small
            height="44"
            @click="applyAdvancedFilters"
            style="background: linear-gradient(90deg, #3f5efb, #8f49f3)"
          >
            {{ $t("apply filters") }}
          </v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import mixin from "@/Mixins/mixin";
// import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";
import autocomplete from "../../../../components/general/patial/autocomplete";
import Status from "../../../../components/general/Status/status";
export default {
  name: "pettyFilter",
  mixins: [mixin],
  components: {
    autocomplete,
    // FlexibleAutocomplete,
    Status,
  },
  data() {
    return {
      advancedFilterDrawer: false,
      fromMenu: false,
      toMenu: false,
      maxAmount: null,
      maxAmountTax: null,
      selectedMinAmount: 0,
      selectedMaxAmount: null,
      filters: {
        account: null,
        branch: null,
        sellStatus: null,
        fromDate: null,
        toDate: null,
      },
      advancefilters: {
        UserList: [],
        products: [],
        account: null,
        branch: null,
        sellStatus: null,
        fromDate: null,
        toDate: null,
        productGroup: null,
        attachments: null,
        Receipt: null,
        invoicesErrors: null,
        entrepot: null,
        category: null,
        amountRange: [0, 100],
        amountRangeTax: [0, 100],
      },
    };
  },
  watch: {
    "advancefilters.amountRange": {
      handler: function (val) {
        this.selectedMinAmount = val[0];
        this.selectedMaxAmount = val[1];
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchMaxAmount();
  },
  methods: {
    fetchProductsApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        typeForm: "product",
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "products", { params })
        .then(function (response) {
          let list =
            response && response.data && response.data.data ? response.data.data : [];
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    fetchCustomersApi(payload) {
      var app = this;
      let perPage = 10;
      let params = {
        status: "active",
        personnel: "active",
        page: payload.page,
        options: JSON.stringify({
          itemsPerPage: perPage,
        }),
      };
      if (payload.search) {
        params.search = payload.search;
      }
      return app.$axios
        .get(app.$endpoint + "customer/show", { params })
        .then(function (response) {
          let list =
            response && response.data && response.data.data ? response.data.data : [];
          return {
            items: list,
            hasMore: list.length === perPage,
          };
        });
    },
    resetFilters() {
      Object.assign(this.filters, {
        account: [],
        branch: null,
        sellStatus: null,
        fromDate: null,
        toDate: null,
      });
    },
    resetAdvancedFilters() {
      let Min = 0;
      let Max = this.maxAmount || 100;
      let Max_tax = this.maxAmountTax || 100;
      Object.assign(this.advancefilters, {
        account: [],
        branch: [],
        UserList: [],
        products: [],
        productGroup: null,
        sellStatus: null,
        fromDate: null,
        toDate: null,
        attachments: null,
        Receipt: null,
        invoicesErrors: null,
        entrepot: null,
        category: null,
        amountRange: [Min, Max],
        amountRangeTax: [Min, Max_tax],
      });
    },
    closeStatus() {
      this.filters.sellStatus = null;
    },
    fetchMaxAmount() {
      var app = this;
      this.$axios
        .get(app.$endpoint + "dashboard/charts/max-invoice-price-value")
        .then((response) => {
          app.maxAmount = response.data.maximum_bank_cash_value;
          app.advancefilters.amountRange = [0, app.maxAmount];
          app.selectedMinAmount = 0;
          app.selectedMaxAmount = app.maxAmount;
        })
        .catch((error) => {
          app.maxAmount = 100;
          app.advancefilters.amountRange = [0, 100];
          app.selectedMinAmount = 0;
          app.selectedMaxAmount = 100;
        });
    },

    applyFilters() {
      this.$emit("apply-filters", this.filters);
      this.advancedFilterDrawer = false;
    },
    applyAdvancedFilters() {
      this.$emit("apply-advanced-filters", this.advancefilters);
      this.advancedFilterDrawer = false;
    },
  },
};
</script>
<style scoped>
::v-deep .v-messages.theme--light {
  display: none !important;
}
::v-deep .v-label .v-label--active {
  right: -28px !important;
}
.filters-row .v-input {
  max-width: 100%;
}
</style>
